<template>
  <div class="icon-process-wrapper">
    <div class="icon-process-single wow move-up">
      <div class="icon-process-single__line">
        <div class="dot dot-1"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-5"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-1"></div>
      </div>
      <div class="icon-process-single__content-wrap">
        <div class="icon-process-single__media">
          <i class="fa fa-flask"></i>
        </div>
        <h5 class="icon-process-single__title">Select ingredients</h5>
        <div
          class="icon-process-single__text"
        >Search ingredients from thousands of records, or create and define your own.</div>
      </div>
    </div>
    <div class="icon-process-single wow move-up">
      <div class="icon-process-single__line">
        <div class="dot dot-1"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-5"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-1"></div>
      </div>
      <div class="icon-process-single__content-wrap">
        <div class="icon-process-single__media">
          <i class="fa fa-clipboard"></i>
        </div>
        <h5 class="icon-process-single__title">Define your products</h5>
        <div
          class="icon-process-single__text"
        >Manage your cosmetic products for quality assurance and regulatory compliance.</div>
      </div>
    </div>
    <div class="icon-process-single wow move-up">
      <div class="icon-process-single__line">
        <div class="dot dot-1"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-5"></div>
        <div class="dot dot-4"></div>
        <div class="dot dot-3"></div>
        <div class="dot dot-2"></div>
        <div class="dot dot-1"></div>
      </div>
      <div class="icon-process-single__content-wrap">
        <div class="icon-process-single__media">
          <i class="fa fa-magic"></i>
        </div>
        <h5 class="icon-process-single__title">Generate documentation</h5>
        <div
          class="icon-process-single__text"
        >Generate PIF documents based on custom business templates.</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Gradation",
};
</script>
